import React, { Component } from 'react'
import { CommonDeleteButton, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import { withTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Stack, Tooltip, RadioGroup, FormControlLabel, Radio, IconButton, Typography } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import RepeatIcon from '@mui/icons-material/Repeat';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class DocTestLeft extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Testdata: [],
      isDeleteCliked: false,
      SelectedList: {},
      PatientData: this.props?.PatientData,
      TestTransmitted: false,
      showDataType: "all",
      selectionModel: [],
      selectedRows: [],
      radSelectedRows: [],
    }
  }

  componentDidUpdate(prevprops) {
    if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.GetTestdata() }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  GetTestdata() {
    try {
      RestAPIService.getAll(Serviceurls.DOC_TEST_GET + `?patient_id=${this.state.PatientData?.patient_id}&appointment_id=${this.state.PatientData?.appointment_id}`).
        then((response) => {
          if (response.data.status === "success") {
            let TestList = []
            // response.data.data?.forEach((item) => {
            //   item.display_label = item?.lab_test_names ? item?.lab_test_names :
            //     item?.lab_set_names ? item?.lab_set_names :
            //       item?.special_test_name ? item?.special_test_name :
            //         item?.service_name && item?.service_type ? `${item?.service_type} - ${item?.service_name}` :
            //           item?.package_name ? item?.package_name : "";
            //   item.type = item.transmitted_radiology_id ? "Radiology": "Laboratory";
            //   TestList.push(item)
            // })
            this.setState({
              Testdata: response.data.data,
              TestTransmitted: response.data?.is_transmitted ? response.data?.is_transmitted : false
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  onEditHandler(data) {
    this.props.EditAllergyData(data.row)
  }
  onDeleteHandler(data) {
    try {
      this.setState({
        isDeleteCliked: true,
        SelectedList: data.row,
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  popupClose() {
    this.setState({ isDeleteCliked: false })
  }
  DeleteAllergy() {
    try {
      let data = {
        appointment_id: this.props?.PatientData?.appointment_id,
        tests_id: this.state.SelectedList?.id
      }
      RestAPIService.create(data, Serviceurls.DOC_TEST_GET).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({ isDeleteCliked: false, SelectedList: {} }, () => { this.GetTestdata() })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  clearCheckList = () => {
    this.setState({
      showDataType: "all",
      selectionModel: [],
      selectedRows: [],
      radSelectedRows: [],
    })
  }

  postTestTransmitData = () => {
    try {
      let testIds = [];
      this.state.Testdata?.forEach(element => {
        testIds?.push(element?.id)
      });
      let data = {
        appointment_id: this.props?.PatientData?.appointment_id,
        patient_id: this.props?.PatientData?.patient_id,
        line_item_ids: this.state.selectedRows, // transmit list of laboratory
        radiology_line_items: this.state.radSelectedRows, // transmit list of radiology
      }
      RestAPIService.create(data, Serviceurls.TEST_TRANSMIT)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.clearCheckList();
            this.GetTestdata()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ postLoading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ postLoading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  printTestData = () => {
    try {
        const BasePath = localGetItem("isNewBilling") === "true" ? Serviceurls.New_DOCTOR_NOTES_PRINT : Serviceurls.DOC_DOCTOR_NOTES_TEST_PRINT
        RestAPIService.getAll( BasePath + `?appointment_id=${this.props?.PatientData?.appointment_id}&patient_id=${this.props?.PatientData?.patient_id}`).
            then((response) => {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
    } catch (error) {
        this.errorMessage(error.message)
    }
}

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  handleTableCheckbox = (selectedIds) => {
    let states = this.state;
    let selectedSet = new Set(selectedIds);
    let previousSelection = new Set(this.state.selectionModel); // Previous selected rows
    let updatedSelection = new Set(selectedIds); // New selection

    // Step 1: Identify package IDs for selection
    let packageIdsToSelect = new Set();
    states.Testdata.forEach(row => {
        if (selectedSet.has(row.id) && row.package_id) {
            packageIdsToSelect.add(row.package_id);
        }
    });

    // Step 2: Add all rows belonging to selected package IDs
    states.Testdata.forEach(row => {
        if (packageIdsToSelect.has(row.package_id)) {
            updatedSelection.add(row.id);
        }
    });

    // Step 3: Identify package IDs for deselection
    let deselectedIds = [...previousSelection].filter(id => !selectedSet.has(id)); // Previously selected but now removed
    let packageIdsToDeselect = new Set();

    deselectedIds.forEach(id => {
        let deselectedRow = states.Testdata.find(row => row.id === id);
        if (deselectedRow && deselectedRow.package_id) {
            packageIdsToDeselect.add(deselectedRow.package_id);
        }
    });

    // Step 4: Remove all rows belonging to deselected package IDs
    states.Testdata.forEach(row => {
        if (packageIdsToDeselect.has(row.package_id)) {
            updatedSelection.delete(row.id);
        }
    });

    // Step 5: Categorize selected data into lab and radiology lists
    const filteredData = states.Testdata.reduce(
        (acc, element) => {
            if (updatedSelection.has(element.id)) {
                if (element.type === "Laboratory") {
                    acc.labSelectedList.push(element);
                } else {
                    acc.radSelectedList.push(element);
                }
            }
            return acc;
        },
        { labSelectedList: [], radSelectedList: [] }
    );

    // Step 6: Update state with selected rows
    this.setState({
        selectedRows: filteredData.labSelectedList,
        radSelectedRows: filteredData.radSelectedList,
        selectionModel: [...updatedSelection],
        isCheckClicked: updatedSelection.size > 0,
    });
};


  render() {
    try {
      const { t } = this.props
      const states = this.state;
      // this.state.Testdata?.forEach((element, index) => { element.sno = index + 1 });
      const filteredList = states.Testdata?.reduce((acc, element) => {
        if (element?.type?.toLowerCase() === states.showDataType) {
          acc.push({
            ...element,
            sno: acc.length + 1,
          });
        }
        return acc;
      }, []);

      const columns = [
        {
          field: "display_label", flex: 0.3, headerName: t("Service Description"),
          renderCell: (params) => {
            return (
              <Box component={'div'} emed_tid={`doc_test_left_service_desc_cell_${params.row.id}`}>
                {params?.row?.service_name ? params?.row?.service_name?.length > 25 ?
                  <Tooltip placement='top' title={params?.row?.service_name} arrow emed_tid={`doc_test_left_service_desc_tooltip_${params.row.id}`}>
                    <div emed_tid={`doc_test_left_service_desc_text_${params.row.id}`}>{params?.row?.service_name.slice(0, 23) + "..."}</div></Tooltip> :
                  (params?.row?.service_name || '-') : params?.row?.package_name ? params?.row?.package_name?.length > 25 ?
                  <Tooltip placement='top' title={params?.row?.package_name} arrow emed_tid={`doc_test_left_package_tooltip_${params.row.id}`}>
                    <div emed_tid={`doc_test_left_package_text_${params.row.id}`}>{params?.row?.package_name.slice(0, 23) + "..."}</div></Tooltip> :
                  (params?.row?.package_name || '-') : params?.row?.special_test_name?.length > 25 ?
                  <Tooltip placement='top' title={params?.row?.special_test_name} arrow emed_tid={`doc_test_left_special_test_tooltip_${params.row.id}`}>
                    <div emed_tid={`doc_test_left_special_test_text_${params.row.id}`}>{params?.row?.special_test_name.slice(0, 23) + "..."}</div></Tooltip> :
                  (params?.row?.special_test_name || '-')}
                  {params?.row?.package_name ? <Typography fontSize={'.8vw'} emed_tid={`doc_test_left_package_typography_${params.row.id}`}>{params?.row?.package_name}</Typography> : null}
              </Box>
            )
          }
        },
        {
          field: "type", flex: 0.25, headerName: t("Module"),
          renderCell: ({ row }) => (<Box component={'div'} emed_tid={`doc_test_left_module_cell_${row.id}`}>
            {row?.type ? row?.type : "-"}
          </Box>)
        },
        {
          field: "status", flex: 0.2, headerName: t("Status"), headerAlign: "center", align: 'center',
          renderCell: (params) => (<Box component={'div'} emed_tid={`doc_test_left_status_cell_${params.row.id}`}>
            {params?.row?.status ? params?.row?.status : params?.row?.is_transmitted ? 'Inprogress' : "Await to transmit"}
          </Box>)
        },
        {
          field: "action", flex: 0.15, headerName: t("Action"), headerAlign: "center", align: "center",
          renderCell: (params) => {
            const selectedIds = new Set(this.state.selectionModel || []);
            const list = params?.row?.package_lines?.map((item, index) => `${index + 1}. ${item.service_name}, `)
              
            return (<Box display={"flex"} flexDirection={"row"} alignItems={"center"} emed_tid={`doc_test_left_action_cell_${params.row.id}`}>  
              {params?.row?.package_lines?.length > 0 ? <Tooltip title={list} placement='top' emed_tid={`doc_test_left_view_tooltip_${params.row.id}`}><IconButton size="small" sx={{width: '1vw', height: '1vw', marginRight: '1vw'}} emed_tid={`doc_test_left_view_btn_${params.row.id}`}><VisibilityIcon color='primary' emed_tid={`doc_test_left_view_icon_${params.row.id}`}/></IconButton></Tooltip> : null}
              <CommonDeleteButton size={"1.2vw"}
                disable={this.props?.isLocked || params?.row?.is_transmitted || selectedIds.has(params.row.id)}
                onClick={this.onDeleteHandler.bind(this, params)}
                emed_tid={`doc_test_left_delete_btn_${params.row.id}`} />
            </Box>)
          }
        }
      ]

      // if (states.showDataType === "all") {
      //   columns.unshift({
      //     field: "sno", flex: 0.1, headerName: t("S No"), headerAlign: "center", align: 'center',
      //     renderCell: ({ row, api }) => (api.getRowIndex(row.id) + 1)
      //   })
      // }

      return (
        <ShowComponents onIntersection={this.GetTestdata.bind(this)} emed_tid="doc_test_left_show_component">
          <Box display={'flex'} justifyContent={'flex-end'} emed_tid="doc_test_left_actions_box">
            <Box component={'div'} className="eMed_CheckBox_Group" emed_tid="doc_test_left_radio_group_box">
              {/* <RadioGroup
                value={this.state.showDataType}
                sx={{ display: 'flex', flexDirection: 'row' }}
                onChange={(e) => {
                  this.setState({
                    showDataType: e.target.value,
                    selectionModel: [],
                    selectedRows: [],
                  })
                }}
              >
                <FormControlLabel emed_tid= 'doc_test_radio_all' value={'all'} control={<Radio size='small' />} label="All" />
                <FormControlLabel emed_tid= 'doc_test_radio_lab' value={'laboratory'} control={<Radio size='small' />} label="Laboratory Test" />
                <FormControlLabel emed_tid= 'doc_test_radio_rad' value={'radiology'} control={<Radio size='small' />} label="Radiology Test" />
              </RadioGroup> */}
            </Box>
            <Button
              className='Common_Btn_Min_Width'
              onClick={() => this.printTestData()}
              emed_tid="doc_test_left_print_btn"
            >
              <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} emed_tid="doc_test_left_print_icon" />
            </Button>
            <Tooltip title={"Transmit"} arrow placement='top' emed_tid="doc_test_left_transmit_tooltip">
              <Button
                // disabled={this.state.TestTransmitted || this.props.isLocked || this.state.Testdata?.length === 0}
                disabled={this.state.Testdata?.every(item => item?.is_transmitted) || this.props.isLocked || this.state.Testdata?.length === 0 || this.state.selectionModel?.length === 0}
                onClick={() => { this.postTestTransmitData() }}
                startIcon={<RepeatIcon emed_tid="doc_test_left_transmit_icon" />}
                variant='outlined'
                size='small'
                sx={{ marginX: '0.5vw', marginBottom: '0.5vw', textTransform: 'capitalize' }}
                emed_tid="doc_test_left_transmit_btn"
              >Transmit</Button>
            </Tooltip>
          </Box>
          <Box height={'20vh'} overflow={'auto'} emed_tid="doc_test_left_datagrid_box">
            <DataGrid
              emed_tid="doc_test_left_datagrid"
              density='compact'
              rows = {states.Testdata}
              columns={columns}
              getRowId={(row) => row['id']} // kindly don't change this! the transmit works based on this ID.
              checkboxSelection
              selectionModel={states.selectionModel}
              onSelectionModelChange={(selectedIds) => this.handleTableCheckbox(selectedIds)}
              headerHeight={40}
              hideFooter={true}
              components={{
                NoRowsOverlay: () => (
                  <Stack className='eMed_DocNotes_nodata' emed_tid="doc_test_left_no_rows_overlay">
                    {t("NoRecordsFound")}
                  </Stack>
                )
              }}
              disableSelectionOnClick
              isRowSelectable={(params) => !(params.row.is_transmitted || params.row.type === 'Special Test')}

            />
          </Box>
          {this.state.isErrorMsg ?
            <ToastMsg
              emed_tid="doc_test_left_error_toast"
              severity={'error'}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.successMsg ?
            <ToastMsg
              emed_tid="doc_test_left_success_toast"
              severity={'success'}
              msg={this.state.successMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.isDeleteCliked ? <DeletePopup
            emed_tid="doc_test_left_delete_popup"
            DeletTitle={`${t("deleteMsg")} ${t("Test")} ${this.state.SelectedList.service_name ? this.state.SelectedList?.service_name : this.state.SelectedList?.special_test_name ? this.state.SelectedList?.special_test_name :
              this.state.SelectedList?.package_name ? this.state.SelectedList?.package_name : this.state.SelectedList?.lab_set_names ?  this.state.SelectedList?.lab_set_names : "-"} ?`}
            deleteAlertPopupClose={this.popupClose.bind(this)}
            removeData={this.DeleteAllergy.bind(this)}
          /> : null}
        </ShowComponents>
      )
    }
    catch (e) {

    }
  }
}
export default withTranslation()(DocTestLeft)